/**
 * LegalLayout — Minimal shared wrapper for static legal pages.
 *
 * No OperatorShell so unauthenticated visitors can read terms and privacy
 * straight from the login page footer. Mi6 brand band sits at the top.
 */
import { Link } from "wouter";
import Mi6BrandBand from "@/components/dashboards/Mi6BrandBand";
import { tokens } from "@/components/operator/tokens";

export default function LegalLayout({ title, lastUpdated, children }: {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}) {
  return (
    <div style={{ minHeight: "100vh", background: "#FFFFFF", display: "flex", flexDirection: "column" }}>
      <Mi6BrandBand rightLabel="Legal" />
      <main style={{ flex: 1, maxWidth: 760, margin: "0 auto", padding: "40px 24px 80px", width: "100%" }}>
        <Link href="/login" style={{
          fontSize: 12,
          color: tokens.color.textMuted,
          textDecoration: "none",
          display: "inline-block",
          marginBottom: 24,
        }}>
          &larr; Back to sign in
        </Link>
        <h1 style={{
          fontFamily: tokens.font.display,
          fontSize: 32,
          fontWeight: 700,
          letterSpacing: "-0.02em",
          margin: "0 0 8px",
          color: tokens.color.textPrimary,
        }}>
          {title}
        </h1>
        <p style={{ fontSize: 12, color: tokens.color.textMuted, margin: "0 0 32px" }}>
          Last updated: {lastUpdated}
        </p>
        <article style={{
          fontSize: 14,
          lineHeight: 1.7,
          color: tokens.color.textPrimary,
        }}>
          {children}
        </article>
        <footer style={{
          marginTop: 64,
          paddingTop: 24,
          borderTop: `1px solid ${tokens.color.border}`,
          fontSize: 12,
          color: tokens.color.textMuted,
          display: "flex",
          gap: 16,
          flexWrap: "wrap",
        }}>
          <Link href="/legal/terms" style={{ color: "inherit" }}>Terms of Service</Link>
          <Link href="/legal/privacy" style={{ color: "inherit" }}>Privacy Policy</Link>
          <span>Mi6 Group · Attilius</span>
          <a href="mailto:support_team@mi6group.com" style={{ color: "inherit" }}>support_team@mi6group.com</a>
        </footer>
      </main>
    </div>
  );
}

export const legalH2: React.CSSProperties = {
  fontFamily: "inherit",
  fontSize: 18,
  fontWeight: 700,
  marginTop: 28,
  marginBottom: 8,
  letterSpacing: "-0.01em",
};

export const legalP: React.CSSProperties = {
  margin: "0 0 12px",
};

export const legalUl: React.CSSProperties = {
  margin: "0 0 12px",
  paddingLeft: 22,
};
